import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { monitoringAPI } from '../services/api';

export function MonitoringLogsPage() {
  const [page, setPage] = useState(1);

  const { data: logsData, isLoading } = useQuery({
    queryKey: ['monitoring', 'conversations', page],
    queryFn: () => monitoringAPI.conversations(page, 50),
  });

  const logs = logsData?.data || [];

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">대화 로그</h1>
        <p className="text-gray-600">전체 대화 내역을 확인합니다.</p>
      </div>

      {isLoading ? (
        <div className="bg-white rounded-lg shadow p-12 text-center text-gray-500">로딩 중...</div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">테넌트</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">세션 ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">메시지</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">토큰</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">상태</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">시작</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">종료</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {logs.map((log: any) => (
                <tr key={log.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">{log.tenant_name}</td>
                  <td className="px-6 py-4 text-gray-500 text-sm font-mono">
                    {log.session_id.slice(0, 12)}...
                  </td>
                  <td className="px-6 py-4 text-gray-600">{log.message_count}</td>
                  <td className="px-6 py-4 text-gray-600">{(log.total_tokens || 0).toLocaleString()}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 text-xs rounded-full ${
                      log.is_active
                        ? 'bg-green-100 text-green-800'
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                      {log.is_active ? '활성' : '종료'}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-500 text-sm">
                    {new Date(log.created_at).toLocaleString('ko-KR')}
                  </td>
                  <td className="px-6 py-4 text-gray-500 text-sm">
                    {log.ended_at ? new Date(log.ended_at).toLocaleString('ko-KR') : '-'}
                  </td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr>
                  <td colSpan={7} className="px-6 py-8 text-center text-gray-400">대화 기록이 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* 페이징 */}
          <div className="flex justify-center gap-2 p-4 border-t border-gray-200">
            <button
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page <= 1}
              className="px-4 py-2 text-sm bg-white border rounded-lg hover:bg-gray-50 disabled:opacity-50"
            >
              이전
            </button>
            <span className="px-4 py-2 text-sm text-gray-600">{page} 페이지</span>
            <button
              onClick={() => setPage((p) => p + 1)}
              disabled={logs.length < 50}
              className="px-4 py-2 text-sm bg-white border rounded-lg hover:bg-gray-50 disabled:opacity-50"
            >
              다음
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
